module.exports = __webpack_public_path__ + "img/saintkentigern-thumb.dea5dca2.jpg";